// Imports
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { XhrService } from '../../../service/xhr.service';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { PostBody } from '../../../shared/postBody';

import { Role } from './role';

@Injectable()
export class RoleService {
    // Resolve HTTP using the constructor
    constructor(private xhrService: XhrService) {
    }

    getInfo() {
        return this.xhrService.get('role/getInfo/');
    }

    getClone(id: number) {
        return this.xhrService.get('role/getInfo/' + id);
    }

    get(id: number) {
        return this.xhrService.get('role/read/' + id);
    }

    getAll() {
        return this.xhrService.get('role/read/');
    }

    create(role:Role) {
        let postBody:PostBody={method:'role.create'};
        postBody['role'] = role;
        return this.xhrService.post('role/create/',postBody);
    }

    update(id:number,role:Role) {
        let postBody:PostBody={method:'role.update'};
        postBody['role'] = role;
        return this.xhrService.post('role/update/'+id,postBody);
    }

    delete(id:number) {
        return this.xhrService.get('role/delete/'+id);
    }


}



// WEBPACK FOOTER //
// ./src/app/module/role/shared/role.service.ts